import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props, state) {
  return {
    dropZoneStyle: _objectSpread(_objectSpread(_objectSpread({}, !props.inSidebar && {
      border: "".concat(componentTheme.DnDZoneBorderWidth, " dashed ").concat(componentTheme.DnDZoneBorderColor),
      backgroundColor: componentTheme.DnDZoneBackgroundColor,
      padding: componentTheme.DnDZonePadding,
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    }), props.inSidebar && {
      border: "".concat(componentTheme.sidebarDnDZoneBorderWidth, " dashed ").concat(componentTheme.sidebarDnDZoneBorderColor),
      backgroundColor: componentTheme.sidebarDnDZoneBackgroundColor,
      padding: componentTheme.sidebarDnDZonePadding,
      margin: componentTheme.sidebarDnDZoneMargin,
      color: componentTheme.sidebarDnDZoneColor,
      justifyContent: 'center',
      textAlign: 'center',
      width: '100%',
      '&.inSidebarStimulus': {
        marginLeft: '10%',
        width: '90%'
      }
    }), props.inSidebar && props.inStimulus && {
      marginLeft: '10%',
      width: '90%'
    }),
    wrapper: _objectSpread({
      justifyContent: 'center',
      display: 'flex',
      flex: '1 0 100%',
      width: '100%'
    }, !state.toRender && {
      display: 'none',
      width: '100%'
    })
  };
};
export default generateStyle;